import {
    Outlet,
    Navigate,
    useLocation
} from "react-router-dom"
import styles from "./Main.module.css"

import { Navbar, Footer } from '@/components/layout'

import { ROUTES } from '@/constants/routes'

export function Main() {

    const location = useLocation()

    // Only show the landing page on the exact root URL
    const isLandingPage = location.pathname === "/"

    return (
        <>
            {!isLandingPage ? (
                <div className={styles.container}>
                    <Navbar/>
                    <div className={styles.contentWrapper}>
                        <div className={styles.content}>
                            <Outlet />
                        </div>
                        <Footer />
                    </div>
                </div>
            ) : (
                <Navigate to={ROUTES.home} />
            )}
        </>
    )
}
